import { BaseService } from './base.service';

export class ItemCategoriesService extends BaseService {
  static get resourceEndpoint() {
    return 'item-categories';
  }
}
